// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__nuxt[data-v-45dd39a2],#__nuxt #__layout[data-v-45dd39a2],body[data-v-45dd39a2],html[data-v-45dd39a2]{height:100vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
